import type { Act, Scene, ScriptBlock } from '../types';
import { interpolateSceneIds } from './interpolate-scene-ids';
import { buildSceneOrderIndex } from './scene-order';

export function compareScriptBlocksByDocumentOrder(left: ScriptBlock, right: ScriptBlock): number {
    if (left.pageNumber !== right.pageNumber) return left.pageNumber - right.pageNumber;
    return left.blockIndex - right.blockIndex;
}

export function compareScriptBlocksBySceneOrder(
    sceneOrderIndex: ReadonlyMap<string, number>,
    left: ScriptBlock,
    right: ScriptBlock
): number {
    const leftSceneOrder = getSceneOrder(sceneOrderIndex, left.sceneId);
    const rightSceneOrder = getSceneOrder(sceneOrderIndex, right.sceneId);

    if (leftSceneOrder !== rightSceneOrder) {
        return leftSceneOrder - rightSceneOrder;
    }

    return compareScriptBlocksByDocumentOrder(left, right);
}

export function orderScriptBlocksByShowStructure(
    scriptBlocks: ScriptBlock[],
    acts: Act[],
    scenes: Scene[]
): ScriptBlock[] {
    const sceneOrderIndex = buildSceneOrderIndex(acts, scenes, { includePreset: true });
    const blocksWithSceneIds = interpolateSceneIds(
        scriptBlocks.toSorted(compareScriptBlocksByDocumentOrder)
    );

    return blocksWithSceneIds.toSorted((left, right) =>
        compareScriptBlocksBySceneOrder(sceneOrderIndex, left, right)
    );
}

function getSceneOrder(
    sceneOrderIndex: ReadonlyMap<string, number>,
    sceneId: string | null | undefined
): number {
    if (!sceneId) return Number.POSITIVE_INFINITY;
    return sceneOrderIndex.get(sceneId) ?? Number.POSITIVE_INFINITY;
}
